<template>
  <tr class="">
    <td class="p-t-5 p-b-5 v-align-middle" :data-label="$t('UserNoticePreferences.contact_me_when')">{{ event.title }}</td>
    <td class="checkbox-notice-preference p-t-5 p-b-5 v-align-middle" v-for="reference in noticeReferences" v-if="isDisplay(reference)">
      <div class="checkbox check-primary">
        <input v-model="userEditing.user_preference_attributes[referenceName(reference)]"
               type="checkbox"
               :name="referenceName(reference)"
               :id="referenceName(reference)"
               :disabled="isAttributeDisable(reference)">
        <label :for="referenceName(reference)"></label>
      </div>
    </td>
  </tr>
</template>

<script>
  import { referenceAttributesDisabled, noticeReferences } from '@/settings/users'

  export default {
    name: 'NoticePreferencesRow',
    props: ['event', 'userEditing', "entityAcceptSms"],
    methods: {
      referenceName(reference) {
        return this.event.name + '_' + reference
      },
      isReferenceAcceptSms(reference) {
        return reference == 'accept_sms'
      },
      isAttributeDisable(reference) {
        let referenceName = this.referenceName(reference)
        return referenceAttributesDisabled.includes(referenceName) || (this.isReferenceAcceptSms(reference) && !this.isAcceptSms)
      },
      isDisplay(reference) {
        return this.isReferenceAcceptSms(reference) ? this.isAcceptSms : true
      }
    },
    computed: {
      noticeReferences() {
        return noticeReferences
      },
      isAcceptSms() {
        return this.entityAcceptSms && this.userEditing.user_preference_attributes.accept_sms
      }
    }
  }
</script>

<style type="text/css">
  .checkbox-notice-preference {
    padding-left: 9% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/NoticePreferencesRow.vue